module.exports = __webpack_public_path__ + "static/media/GB-ZET.03e91b6a.svg";